import request from "@/utils/request";

// 验证明信片code码
export function postValidateCode(data) {
    return request({
        url: "/v1/check_order",
        method: "post",
        data,
    });
}
// 上传图片
export function postUploadPic(data) {
    return request({
        url: "/v1/upload_screenshot",
        method: "post",
        data
    });
}
// 提交信息
export function postSubmit(data) {
    return request({
        url: "/v1/create_record",
        method: "post",
        data
    });
}
// 提交信息
export function postUpdateStep(data) {
    return request({
        url: "/v1/update_step",
        method: "post",
        data
    });
}
// viewer, 用户访问数
export function getViewer(data) {
    return request({
        url: "/v1/viewer",
        method: "get",
        data
    });
}
